import React from 'react';
import { MapPinIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface LocationPermissionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAllow: () => void;
}
export function LocationPermissionModal({
  isOpen,
  onClose,
  onAllow
}: LocationPermissionModalProps) {
  return <AnimatePresence data-id="element-4201" data-mp="3abw8rqbq7sw6">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/50 z-[250] backdrop-blur-sm" onClick={onClose} data-id="element-4202" data-mp="au512d7deecy" />

          {/* Bottom Sheet */}
          <motion.div initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed bottom-0 left-0 right-0 z-[260] bg-white rounded-t-3xl shadow-2xl overflow-hidden max-w-lg mx-auto md:mb-6 md:rounded-3xl" onClick={e => e.stopPropagation()} data-id="element-4203" data-mp="uj72buvchlxr">
            {/* Handle for dragging feel */}
            <div className="w-12 h-1.5 bg-gray-200 rounded-full mx-auto mt-3 mb-1 md:hidden" data-id="element-4204" data-mp="3poc1u4tp0ou7" />

            <div className="p-6 pt-4 md:pt-6 relative" data-id="element-4205" data-mp="3bt9x3l0l15iz">
              <button onClick={onClose} className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100 transition-colors" data-id="element-4206" data-mp="3gqtcio90noci">
                <XIcon className="w-5 h-5 text-gray-500" data-id="element-4207" data-mp="36r2g2h0waz9s" />
              </button>

              <div className="flex justify-center mb-6" data-id="element-4208" data-mp="10z5gqw5qo1va">
                <div className="w-20 h-20 bg-gradient-to-br from-[#1E2B55] to-[#162041] rounded-full flex items-center justify-center shadow-xl ring-4 ring-blue-50" data-id="element-4209" data-mp="10znkseyn7kdr">
                  <MapPinIcon className="w-10 h-10 text-white" data-id="element-4210" data-mp="2dyh32z19kvg5" />
                </div>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 text-center mb-3" data-id="element-4211" data-mp="28x9sytbnfk6b">
                Enable Location Services
              </h2>
              <p className="text-gray-600 text-center mb-8 px-2" data-id="element-4212" data-mp="24yu2ugk9tvoo">
                We need your location to show you nearby pharmacies, accurate
                delivery times, and available products in your area.
              </p>

              <div className="space-y-3 mb-6" data-id="element-4213" data-mp="2slse8ztjadfq">
                <button onClick={onAllow} className="w-full bg-[#1E2B55] text-white font-bold py-4 rounded-2xl hover:bg-[#162041] transition-all shadow-lg shadow-blue-900/20 active:scale-[0.98]" data-id="element-4214" data-mp="2sn3sxuoip5lm">
                  Allow Location Access
                </button>
                <button onClick={onClose} className="w-full bg-gray-100 text-gray-900 font-bold py-4 rounded-2xl hover:bg-gray-200 transition-all active:scale-[0.98]" data-id="element-4215" data-mp="3gdzhmixofkon">
                  Not Now
                </button>
              </div>

              <p className="text-xs text-gray-400 text-center pb-2" data-id="element-4216" data-mp="3nvnsyckntib3">
                Your location data is secure and only used to improve your
                shopping experience
              </p>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}